import styled, { keyframes } from "styled-components";
import { DefaultHorizontalPadding, NavbarHeight } from "../../styles/variables";

const slideDown = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const HeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9998; /* Menor que o Header para ficar por baixo */
`;

export const Header = styled.header`
  position: relative;
  z-index: 9999; /* Fica acima do drawer */
  background-color: ${({ theme }) => theme.colors.background};
  width: 100%;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${NavbarHeight};
  padding: 0px ${DefaultHorizontalPadding};
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin: 0 auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.xs}) {
    padding: 0px calc(${DefaultHorizontalPadding} / 2);
  }
`;
export const HeaderNav = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;

export const HeaderNavDrawer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: ${NavbarHeight};
  left: 0;
  width: 100%;
  height: calc(100vh - ${NavbarHeight});
  background-color: ${({ theme }) => theme.colors.background};
  transform: translateY(-100%);
  animation: ${({ $isOpen }) => ($isOpen ? slideDown : "none")} 0.3s ease-out forwards;
  z-index: 9998; /* Atrás do header */
`;

export const HeaderNavMobile = styled.nav`
  display: flex;
  flex-direction: column;
  padding: 0px ${DefaultHorizontalPadding};
`;

export const HeaderMainListItem = styled.li`
  padding: 1.6rem;
  text-align: left;
  border-bottom: 1px solid #cbcdc8;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    border-bottom: none;
    text-align: center;
  }
`;

export const HeaderMenuButtonContainer = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;
